import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './registration.module.scss';
import AuthPageLayout from '../../components/auth-page-layout/AuthPageLayout';
import { useConfirmEmailQuery } from '@api/graphql-codegen';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useAuthToken } from '../../hooks/useAuthToken';
import Spinner from '../../components/spinner/Spinner';

function EmailConfirm () {
  const params = useQueryParams();
  const id = params.get('id');
  const token = params.get('token');
  const { setAuthToken } = useAuthToken();
  const { push } = useHistory();

  const { data, loading, error } = useConfirmEmailQuery({ variables: { input: { id: id!, token: token! } }, skip: !id || !token });

  useEffect(() => {
    if (!id || !token || (error && error.message === 'Invalid link')) {
      push('/expiryRedirect');
    } else if (error && error.message === 'Link expired') {
      push('/expiryRedirect?existing=true');
    } else if (data) {
      setAuthToken(data?.confirmEmail);
      push('/');
    }
  }, [data, error, id, push, setAuthToken, token])

  const loadingContent = useMemo(() => () => {
    return <div className={styles.loading}><Spinner/></div>;
  }, []);

  return (
    <AuthPageLayout loading={loading} title={'Registration'} isRegistration>
      {loadingContent}
    </AuthPageLayout>
  );
}

export default EmailConfirm;
